import { render, staticRenderFns } from "./AdminSalesReg.vue?vue&type=template&id=570ee2be"
import script from "./AdminSalesReg.vue?vue&type=script&lang=js"
export * from "./AdminSalesReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports